var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{attrs:{"pill":"","variant":_vm.get_user_class(_vm.user_type)}},[_vm._v(_vm._s(_vm.get_user_label(_vm.user_type))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }